import NavigationBar from "../../components/01_navigationBar/01_navigationBar";
import Footer from "../../components/02_footer/02_footer";

import img1 from "../../assets/images/hero.png"
import revs from "../../assets/images/grev.png"
import rev from "../../assets/images/rev.png"
import icon from "../../assets/images/ics.png"
import img2 from "../../assets/images/h2.png"
import img3 from "../../assets/images/hearingTestPage/1.jpg"
import icon2 from "../../assets/images/testicon.svg"
import icon3 from "../../assets/images/ricon.svg"
import arrow from "../../assets/images/rwarrow.svg"

import photo1 from "../../assets/final/Images/01_HomePage/01_HeroSection_HeroImage.png"
import photo2 from "../../assets/final/Images/01_HomePage/06_ValueSection_Banner.png"
import photo3 from "../../assets/final/Images/01_HomePage/07_ServiceSection_Card_1.png"
import photo4 from "../../assets/final/Images/01_HomePage/08_ServiceSection_Card_2.jpg"

import rev1 from "../../assets/final/Images/01_HomePage/Homepage_Review_section_1.jpg"
import rev2 from "../../assets/final/Images/01_HomePage/Homepage_Review_section_2.jpg"
import rev3 from "../../assets/final/Images/01_HomePage/Homepage_Review_section_3.jpg"

import ico1 from "../../assets/final/Icons/01_HomePage/01_MilestoneSection_01.svg"
import ico2 from "../../assets/final/Icons/01_HomePage/02_MilestoneSection_02.svg"
import ico3 from "../../assets/final/Icons/01_HomePage/03_MilestoneSection_03.svg"
import ico4 from "../../assets/final/Icons/01_HomePage/04_MilestoneSection_04.svg"

import ico5 from "../../assets/final/Icons/01_HomePage/05_AppointmentSection_01.svg"
import ico6 from "../../assets/final/Icons/01_HomePage/06_AppointmentSection_02.svg"
import ico7 from "../../assets/final/Icons/01_HomePage/07_AppointmentSection_03.svg"

import ico8 from "../../assets/final/Icons/01_HomePage/08_ServiceCard_01_01.svg"
import ico9 from "../../assets/final/Icons/01_HomePage/09_ServiceCard_01_02.svg"
import ico10 from "../../assets/final/Icons/01_HomePage/10_ServiceCard_01_03.svg"

import ico11 from "../../assets/final/Icons/01_HomePage/11_ServiceCard_02_01.svg"
import ico12 from "../../assets/final/Icons/01_HomePage/12_ServiceCard_02_02.svg"
import ico13 from "../../assets/final/Icons/01_HomePage/13_ServiceCard_02_03.svg"

import "./index.css"
import Testimonials from "../../components/03_Testimonials/03_Testimonials";

export default function Index() {
    return (
        <div>
            <NavigationBar />
            <div className="HomePage-HeroSection">
                <div className="HomePage-HeroSection-Info">
                    <div className="HomePage-HeroSection-Info-Top">
                        <div className="HomePage-HeroSection-Info-Top-Card">
                            <p className="Keys">5000+ people improved their hearing with advanced hearing aids</p>
                        </div>
                        <h1 className="Title">Hear Your Loved Ones Clearly Again</h1>
                        <p>
                            Hearing aids help you hear clearly, reconnect with loved ones, and enjoy everyday life with greater comfort and confidence. 
                        </p>
                        <div className="HomePage-HeroSection-Info-Top-Links">
                            <a href="/appointment">Book Your Appointment</a>
                            <a href="/contact">Contact Us</a>
                        </div>
                    </div>
                    <div className="HomePage-HeroSection-Info-Bottom">
                        <img src={revs} alt="" />
                        <p>Trusted by 5,000+ customers across Mumbai, Thane, and Goa</p>
                    </div>
                </div>
                <div className="HomePage-HeroSection-Banner">
                    <img src={photo1} alt="" />
                    <div className="HomePage-HeroSection-Banner-Card">
                        <img src={rev1} alt="" />
                        <div className="HomePage-HeroSection-Banner-Card-Info">
                            <p>Rajesh Mehta</p>
                            <p>My hearing aids helped me enjoy conversations with my family again.</p>
                        </div>
                    </div>
                    <div className="HomePage-HeroSection-Banner-Card">
                        <img src={rev2} alt="" />
                        <div className="HomePage-HeroSection-Banner-Card-Info">
                            <p>Sunita Patil</p>
                            <p>The audiologist helped me choose the perfect hearing aid machine for my needs.</p>
                        </div>
                    </div>
                    <div className="HomePage-HeroSection-Banner-Card">
                        <img src={rev3} alt="" />
                        <div className="HomePage-HeroSection-Banner-Card-Info">
                            <p>Anil Deshmukh</p>
                            <p>The hearing test clinic was professional and the repair service was excellent.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="HomePage-TrustSection">
                <div className="HomePage-TrustSection-Card">
                    <img src={ico1} alt="" />
                    <p className="Quotes">5,000+</p>
                    <p>Happy customers supported with hearing care</p>
                </div>
                <div className="HomePage-TrustSection-Card">
                    <img src={ico2} alt="" />
                    <p className="Quotes">Expert Care</p>
                    <p>Hearing care tailored to every lifestyle</p>
                </div>
                <div className="HomePage-TrustSection-Card">
                    <img src={ico3} alt="" />
                    <p className="Quotes">25+</p>
                    <p>Years of Experience</p>
                </div>
                <div className="HomePage-TrustSection-Card">
                    <img src={ico4} alt="" />
                    <p className="Quotes">6 Locations</p>
                    <p>Serving Thane, Mumbai, and Goa</p>
                </div>
            </div>
            <div className="HomePage-WhyUsSection">
                <img src={photo2} alt="" />
                <div className="HomePage-WhyUsSection-Info">
                    <h2>Hear Life More <span>Clearly</span>  with Advanced Hearing Aids</h2>
                    <p>
                        Hearing loss can affect your confidence, relationships, and daily comfort. Personalized hearing aids and expert audiologist guidance help you stay connected to the people and moments that matter most. From hearing tests and hearing aid machine fitting to reliable hearing aid repair service, every solution is focused on improving your quality of life.
                    </p>
                </div>
            </div>
            <div className="HomePage-ProcessSection">
                <div className="HomePage-ProcessSection-Flex">
                    <div className="HomePage-ProcessSection-Card">
                        <div className="HomePage-ProcessSection-Info">
                            <h3>Book an Appointment</h3>
                            <p>Schedule a hearing test with an experienced audiologist.</p>
                        </div>
                        <img src={ico5} alt="" />
                    </div>
                    <div className="HomePage-ProcessSection-Card">
                        <div className="HomePage-ProcessSection-Info">
                            <h3>Diagnosis & Hearing Assessment</h3>
                            <p>Advanced audiometry tests help identify the right hearing aids for your needs.</p>
                        </div>
                        <img src={ico6} alt="" />
                    </div>
                    <div className="HomePage-ProcessSection-Card">
                        <div className="HomePage-ProcessSection-Info">
                            <h3>Enjoy Better Hearing</h3>
                            <p>Reconnect with conversations and daily life with confidence.</p>
                        </div>
                        <img src={ico7} alt="" />
                    </div>
                </div>
                <a href="/appointment">Book Your Appointment</a>
            </div>
            <div className="HomePage-ServicesSection">
                <div className="HomePage-ServicesSection-Card">
                    <img src={photo3} alt="" />
                    <div className="HomePage-ServicesSection-Card-Info">
                        <h2>Hearing Test (Pure Tone Audiometry)</h2>
                        <p>
                            Get a clear understanding of your hearing with our comprehensive hearing assessment using advanced diagnostic equipment and experienced audiologists.
                        </p>
                        <div className="HomePage-ServicesSection-Card-Info-Flex">
                            <div  className="HomePage-ServicesSection-Card-Bullets">
                                <img src={ico8} alt="" />
                                <p>Accurate hearing assessment</p>
                            </div>
                            <div  className="HomePage-ServicesSection-Card-Bullets">
                                <img src={ico9} alt="" />
                                <p>Sound-treated testing room</p>
                            </div>
                            <div  className="HomePage-ServicesSection-Card-Bullets">
                                <img src={ico10} alt="" />
                                <p>Expert audiologist evaluation</p>
                            </div>
                        </div>
                        <a href="/hearing-solutions">
                            <p>book now</p>
                            <img src={arrow} alt="" />
                        </a>
                    </div>
                </div>
                <div className="HomePage-ServicesSection-Card">
                    <img src={photo4} alt="" />
                    <div className="HomePage-ServicesSection-Card-Info">
                        <h2>Hearing Consultation</h2>
                        <p>
                            Discuss your hearing concerns with our experienced audiologists and receive honest guidance, expert advice, and personalized recommendations.
                        </p>
                        <div className="HomePage-ServicesSection-Card-Info-Flex">
                            <div  className="HomePage-ServicesSection-Card-Bullets">
                                <img src={ico11} alt="" />
                                <p>One-on-one consultation</p>
                            </div>
                            <div  className="HomePage-ServicesSection-Card-Bullets">
                                <img src={ico12} alt="" />
                                <p>Personalized guidance</p>
                            </div>
                            <div  className="HomePage-ServicesSection-Card-Bullets">
                                <img src={ico13} alt="" />
                                <p>Tailored hearing solutions</p>
                            </div>
                        </div>
                        <a href="/hearing-solutions">
                            <p>book now</p>
                            <img src={arrow} alt="" />
                        </a>
                    </div>
                </div>
            </div>
            <a href="/hearing-solutions" className="HomePage-ServicesSection-view">view all</a>
            <div className="HomePage-AppointmentSection">
                <div className="HomePage-AppointmentSection-Info">
                    <h3>Take the First Step Toward Better Hearing</h3>
                    <p>
                        A professional hearing test can help you understand your hearing needs and find the right hearing aids for your lifestyle.
                    </p>
                    <a href="/appointment">Book Your Appointment</a>
                </div >
                <p className="Quotes">
                    Get accurate hearing tests, expert guidance, and personalized hearing aid recommendations with advanced technology and experienced professionals.
                </p>
            </div>
            <Testimonials />
            <Footer />
        </div>
    );
}